import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Link2, CreditCard, Settings, Plus, Zap, Menu, X, LogOut, ChevronRight } from 'lucide-react';

export default function MobileNav({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const nav = [
    { to: '/', icon: <LayoutDashboard size={20} />, label: 'Home' },
    { to: '/integrations', icon: <Link2 size={20} />, label: 'Connect' },
    { to: '/billing', icon: <CreditCard size={20} />, label: 'Billing' },
    { to: '/settings', icon: <Settings size={20} />, label: 'Settings' },
  ];

  const isActive = (to) => to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <>
      {/* Top bar */}
      <div className="mobile-nav">
        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <div style={{ width: 30, height: 30, background: 'linear-gradient(135deg, #6366f1, #a855f7)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 16px rgba(99,102,241,0.5)' }}>
            <Zap size={16} color="white" fill="white" />
          </div>
          <span style={{ fontFamily: 'Bebas Neue', fontSize: 18, letterSpacing: '0.05em' }}>ASTRA</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button className="btn btn-primary btn-sm" onClick={() => navigate('/new')} style={{ fontSize: 12 }}>
            <Plus size={13} /> New
          </button>
          <button onClick={() => setMenuOpen(!menuOpen)} style={{ background: 'var(--bg3)', border: '1px solid var(--border2)', borderRadius: 8, padding: 7, cursor: 'pointer', color: 'var(--text)', display: 'flex', alignItems: 'center' }}>
            {menuOpen ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {/* Slide-out menu */}
      {menuOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex' }}>
          <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.7)' }} onClick={() => setMenuOpen(false)} />
          <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: 260, background: 'var(--bg2)', borderLeft: '1px solid var(--border)', display: 'flex', flexDirection: 'column', padding: 20 }}>
            {/* User info */}
            {user && (
              <div style={{ padding: '14px 16px', background: 'var(--bg3)', borderRadius: 12, border: '1px solid var(--border)', marginBottom: 20, marginTop: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ width: 38, height: 38, borderRadius: '50%', background: 'linear-gradient(135deg, var(--accent), var(--purple))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 800, color: 'white', flexShrink: 0 }}>
                    {user.full_name?.[0]?.toUpperCase() || 'U'}
                  </div>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700 }}>{user.full_name}</div>
                    <div style={{ fontSize: 11, color: 'var(--text3)', textTransform: 'uppercase', fontWeight: 700 }}>{user.tier} plan</div>
                  </div>
                </div>
              </div>
            )}

            <div style={{ fontSize: 9, fontWeight: 800, color: 'var(--text3)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 8 }}>Menu</div>

            {nav.map(item => (
              <button key={item.to} onClick={() => { navigate(item.to); setMenuOpen(false); }} style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: 12,
                padding: '13px 14px', borderRadius: 10, marginBottom: 4,
                background: isActive(item.to) ? 'var(--accent-glow)' : 'transparent',
                border: `1px solid ${isActive(item.to) ? 'rgba(99,102,241,0.3)' : 'transparent'}`,
                color: isActive(item.to) ? 'var(--accent3)' : 'var(--text2)',
                fontSize: 15, fontWeight: isActive(item.to) ? 700 : 500,
                cursor: 'pointer', fontFamily: 'Geist', textAlign: 'left',
              }}>
                {item.icon} {item.label}
                <ChevronRight size={14} style={{ marginLeft: 'auto' }} />
              </button>
            ))}

            <div style={{ flex: 1 }} />
            <button onClick={() => { onLogout(); setMenuOpen(false); }} style={{
              width: '100%', display: 'flex', alignItems: 'center', gap: 10,
              padding: '12px 14px', borderRadius: 10, background: 'var(--red-bg)',
              border: '1px solid rgba(239,68,68,0.25)', color: 'var(--red)',
              fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'Geist'
            }}>
              <LogOut size={16} /> Sign Out
            </button>
          </div>
        </div>
      )}

      {/* Bottom tab bar */}
      <div className="mobile-bottom-nav">
        {nav.map(item => (
          <button key={item.to} onClick={() => navigate(item.to)} style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
            background: 'none', border: 'none', cursor: 'pointer', padding: '4px 12px',
            color: isActive(item.to) ? 'var(--accent3)' : 'var(--text3)',
            fontFamily: 'Geist', transition: 'color 0.15s'
          }}>
            {item.icon}
            <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.03em' }}>{item.label}</span>
            {isActive(item.to) && <div style={{ width: 4, height: 4, borderRadius: '50%', background: 'var(--accent)', marginTop: -2 }} />}
          </button>
        ))}
      </div>
    </>
  );
}
